import ValidService from "../../../../../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
  name: undefined, // required Tên agent
  params: [
    // {
    // timePushData: undefined //
    // }
  ]
};

// validation form
model.validForm = {
  name: [ValidService.required, ValidService.checkSpaceString],
  params: [
    {
      timePushData: [ValidService.required]
    }
  ],
  password: [ValidService.required],
  timePushDataDevice: [ValidService.requiredChange]
};

// dữ liệu mẫu các form khác
model.dataFormOther = {
  command: undefined,
  agent_id: undefined, // required Agent Id
  params: [], // optional Tham số của command dạng string
  times: 0, // required Số lần
  ip: undefined,
  password: undefined,
  timePushDataDevice: undefined
};
// model getAddedEmployee
model.dataFormGetAddedEmployee = {
  command: undefined,
  agent_id: undefined, // required Agent Id
  params: [], // optional Tham số của command dạng string
  times: 0, // required Số lần
};

model.dataForm1 = {
  command: undefined,
  agent_id: undefined, // required Agent Id
  id: undefined,
  params: [], // optional Tham số của command dạng string
  password: undefined
};
model.dataForm2 = {
  command: undefined,
  agent_id: undefined, // required Agent Id
  id: undefined,
  params: [], // optional Tham số của command dạng string
  timePushDataDevice: undefined
};

model.tableRules = {
  data: [],
  lengthMenu: [30],
  allowPaging: true,
  allowSorting: true,
  allowSelect: false,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 30,
  offset: 0,
  sort: "",
  defaultSort: ["", "ascending"],
  filters: "",
  recordSelected: [],
  dataSearch: {
    value: {},
    valid: {},
    operator: {}
  }
};

export default model;
